import { ILocationItemResponse } from "../services/location-list/location-list.interface";

// `otpVerify.user.location` is the bare location id while `getProfile.location`
// is the expanded object, so a profile read from either source goes through
// this accessor before being sent back as an id.
export const getLocationId = (location?: ILocationItemResponse | string | null): string => {
  if (typeof location === "string") {
    return location;
  }

  return location?.idLocation ?? "";
};
